import { List } from 'immutable'

export type Locale =
  | 'global'
  | 'ae'
  | 'au'
  | 'be_nl'
  | 'be_fr'
  | 'cn'
  | 'de'
  | 'dk'
  | 'es'
  | 'fr'
  | 'hk'
  | 'ie'
  | 'in'
  | 'it'
  | 'fi'
  | 'mx'
  | 'my'
  | 'nl'
  | 'no'
  | 'ru'
  | 'se'
  | 'uk'
  | 'na'
  | 'us'
  | 'pl'
  | 'en'
  | 'na-fr'
  | 'na-es'
  | 'ib'

type Language = 'nl' | 'fr' | 'en' | 'pl' | 'de' | 'es' | 'it' | 'fi'

export const getDrupalLanguage = (l: Locale): Language =>
  l == 'be_nl'
    ? 'nl'
    : l == 'be_fr'
    ? 'fr'
    : l == 'na-fr'
    ? 'fr'
    : l == 'na-es'
    ? 'es'
    : l == 'fr'
    ? 'fr'
    : l == 'pl'
    ? 'pl'
    : l == 'fi'
    ? 'fi'
    : l == 'es'
    ? 'es'
    : l == 'it'
    ? 'it'
    : l == 'de'
    ? 'de'
    : l == 'nl'
    ? 'nl'
    : 'en'

export type ParsedMenuItem = {
  key: string
  label: string
  relative: boolean
  url: string
  children?: List<ParsedMenuItem>
}

export type PaginatedItem<T> = {
  items: List<T>
  pager: Pager
}

export type Pager = {
  current_page: number
  total_items: number
  total_pages: number
  items_per_page: number
}
